import axios from 'axios';

const baseUrl = "https://api.iskenderun.bel.tr/";

export const getSlidersByPageCode = async (pageCode) => {
    try {
        const response = await axios.post(`${baseUrl}GetSlidersByPageCode`, {
            pageCode: pageCode
        });
        return response.data;
    } catch (error) {
        console.error('Slider verisi alınırken hata:', error);
        throw error;
    }
};
